import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import style from './styles/style.module.css';

import ImageCropModal from './modal';

class ImageCropModalWrapper  extends PureComponent {
    static propTypes = {
        children: PropTypes.element.isRequired,
    };
    constructor(props) {
        super(props);
        this.setImageCropSource = this.setImageCropSource.bind( this );
        this.cropFinish = this.cropFinish.bind( this );
        this.imageCrop = this.imageCrop.bind( this );

        this.state = {
            imageSrc: null,
            selectedImage: null,
        };
    }
    setImageCropSource( event ) {
        var files = event.target.files;
        if( files.length > 0 ) {
            var target = files[0];
            if( target.size < 15000000 ) {
                var fReader = new FileReader();
                fReader.readAsDataURL( target );
                fReader.onloadend = function( e ){
                    this.setState( { imageSrc: e.target.result } );
                }.bind( this );
            } else {
                alert( 'File exceeds maximum upload size.' );
            }
        }
        event.target.value = null;
    }
    cropFinish( imageDataUrl ) {
        this.setState( { imageSrc: null } );
        if( this.props.onFinish ) {
            this.props.onFinish( imageDataUrl );
        }
    }
    imageCrop() {
        const aspectRatio = ( this.props.aspectRatio !== undefined ) ? this.props.aspectRatio : 1;
        if( this.state.imageSrc != null ) {
            return (
                <ImageCropModal
                aspectRatio={ aspectRatio }
                src={ this.state.imageSrc }
                onFinish={ this.cropFinish }/>
            );
        }
        return null;
    }
    render() {
        return (
            <div className={ this.props.className } style={ this.props.style }>
                <div style={ { height: '0', width: '0', visibility: 'hidden' } }>
                    <input type="file"
                    onChange={ this.setImageCropSource }
                    className={ style.uploadInput }
                    ref={ ( input ) => { this._fileInput = input; } }
                    accept="image/*" />
                </div>
                <div className={ style.clickWrapper } style={ this.props.wrapperStyle }
                onClick={ () => { this._fileInput.click(); } }>
                    { this.props.children }
                </div>
                { this.imageCrop() }
            </div>
        );
    }
}
ImageCropModalWrapper.defaultProps = {
    className: '',
    wrapperStyle: {},
};

export default connect()( ImageCropModalWrapper );
